import {Image, UnstyledButton} from "@mantine/core";
import React from "react";
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import {useMediaQuery} from "@mantine/hooks";
import cx from "clsx";


interface IProps {
    name: string;
    link?: string;
    country?: string;
    subName?: string;
    flag?: string;
}

const LinkItem: React.FC<IProps> = ( { name, link} ) => {
    const { fontSize } = useGlobalStateStore();
    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    // https://www.stpi.niar.org.tw/public/privacy
    return (
        <UnstyledButton component="a" target="_blank" href={`${link}`}>
            <div className="flex justify-between items-center group relative py-[20px] border-b border-gray-400 border-dotted">

                <div className="flex gap-[35px] items-start">
                    <div className="flex flex-col">
                        <div className={cx("text-[#158a83] font-bold group-hover:text-black", mediaQueryLessSM ? 'text-[22px]' : 'break-all text-[18px]')}>
                            { name }
                        </div>
                        <div
                            className={cx("text-[#b6b6b6] font-bold", mediaQueryLessSM ? 'text-[17px]' : 'break-all text-[14px]')}>{link}
                        </div>
                    </div>
                </div>


                {
                    mediaQueryLessSM && (
                        <div
                            className="absolute top-0 right-0 group-hover:-right-[10px] transition h-full items-center flex">
                            <Image
                                h={11}
                                w={50}
                                src="/images/icon_moreArrow.png"
                                alt="Niar Logo"
                            />
                        </div>
                    )
                }
            </div>
        </UnstyledButton>
    );
}

export const CountryPartnerItem: React.FC<IProps> = ({name, subName, country, flag}) => {
    const {fontSize} = useGlobalStateStore();


    return (
        <div
            className="flex gap-[15px] items-center relative py-[20px] border-b border-gray-400 border-dotted">
            <Image
                h={52}
                w={78}
                src={`/images/flag_${flag}.jpg`}
                alt={`Flag ${country}`}
            />
            <div className="">
                <div
                    className="text-[#666] text-[17px] font-bold">{country}
                </div>
                <div className="text-black text-[22px] font-bold">
                    {name}
                </div>
                <div className="text-[#666] text-[15px]">
                    {subName}
                </div>
            </div>
        </div>
    );
}

export default LinkItem;
